module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 8@2x.112f0ee5.png";